import MuiBaseInputView from './MuiBaseInputView';

export default MuiBaseInputView;
